import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { MotifButtonModule, MotifIconModule } from '@ey-xd/ng-motif';

import { IconoirNavArrowDown, IconoirNavArrowUp } from '@ey-xd/motif-icon';

@Component({
  selector: 'app-expand-button',
  standalone: true,
  imports: [MotifIconModule, MotifButtonModule],
  templateUrl: './expand-button.component.html',
  styleUrl: './expand-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandButtonComponent {
  readonly expanded = model<boolean>(false);
  readonly label = computed(() => (this.expanded() ? 'View Less' : 'View More'));
  readonly icon = computed(() => (this.expanded() ? IconoirNavArrowUp : IconoirNavArrowDown));

  public toggleExpanded(): void {
    this.expanded.update(value => !value);
  }
}
